import script from "./boot-list-top10.vue?vue&type=script&lang=ts&setup=true"
export * from "./boot-list-top10.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__